"use strict";

exports.__esModule = true;
var _MetricChart = require("./MetricChart");
Object.keys(_MetricChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MetricChart[key]) return;
  exports[key] = _MetricChart[key];
});